export const rolePermissionMapping = {
    "01_DOP_ADM": {
        permissions: [
            "Onboard New Data Asset", 
            "Edit Data Asset", 
            "Configure Rules [Add, Edit, Delete]",
            "Weightage",
            "Re-upload Sample Data",
            "Profile/CDE",
            "Rule Approval", 
            "Data Promotion to PROD", 
            "Data Promotion Approval",
        ],
        buttons: {
            "Onboard New Data Asset": true,
            "Edit Data Asset":true, 
            "Re-upload Sample Data": true,
            "Weightage": true,
            "Configure Rules [Add, Edit, Delete]": true,
            "Profile/CDE":true,
            "Rule Approval":true, 
            "Data Promotion to PROD":true, 
            "Data Promotion Approval":true,
        }
    },
    "02_DOP_DAA":{
        permissions: [
        "Onboard New Data Asset", 
        "Edit Data Asset", 
        "Re-upload Sample Data", 
        "Weightage", 
        "Configure Rules [Add, Edit, Delete]", 
        "Rule Approval", 
        "Data Promotion to PROD", 
        "Data Promotion Approval",
        "Profile/CDE"
        ],
        buttons: {
            "Onboard New Data Asset": true,
            "Edit Data Asset":true,
            "Re-upload Sample Data": true,
            "Weightage": true,
            "Configure Rules [Add, Edit, Delete]": true,
            "Rule Approval":true, 
            "Data Promotion to PROD":true, 
            "Data Promotion Approval":true,
            "Profile/CDE":true
        }
    },
    "03_DOP_DAM":{
        permissions: [
        "Onboard New Data Asset", 
        "Edit Data Asset", 
        "Re-upload Sample Data", 
        "Weightage", 
        "Configure Rules [Add, Edit, Delete]", 
        "Rule Approval", 
        "Data Promotion to PROD", 
        "Data Promotion Approval",
        "Profile/CDE"
        ],
        buttons: {
            "Onboard New Data Asset": true,
            "Edit Data Asset":true,
            "Re-upload Sample Data": true,
            "Weightage": true,
            "Configure Rules [Add, Edit, Delete]": true,
            "Rule Approval":true, 
            "Data Promotion to PROD":true, 
            "Data Promotion Approval":true,
            "Profile/CDE":true
        }
    },

    "04_DOP_DAC":{
        permissions: [
        "Onboard New Data Asset", 
        "Edit Data Asset", 
        "Re-upload Sample Data", 
        "Weightage", 
        "Configure Rules [Add, Edit, Delete]", 
        "Rule Approval", 
        "Data Promotion to PROD", 
        "Data Promotion Approval",
        "Profile/CDE"
        ],
        buttons: {
            "Onboard New Data Asset": true,
            "Edit Data Asset":true,
            "Re-upload Sample Data": true,
            "Weightage": true,
            "Configure Rules [Add, Edit, Delete]": true,
            "Rule Approval":false, 
            "Data Promotion to PROD":false, 
            "Data Promotion Approval":false,
            "Profile/CDE":true
        }
    },
    "05_DOP_RM": {
        permissions: [
            "Configure Rules [Add, Edit, Delete]",
            "Weightage",
            "Onboard New Data Asset",
            "Edit Data Asset",
            "Re-upload Sample Data",
            "Profile/CDE",
            "Rule Approval", 
            "Data Promotion to PROD", 
            "Data Promotion Approval"
        ],
        buttons: {
            "Onboard New Data Asset": false,
            "Edit Data Asset":false,
            "Re-upload Sample Data": false,
            "Weightage": false,
            "Configure Rules [Add, Edit, Delete]": true,
            "Profile/CDE":false,
            "Rule Approval":false, 
            "Data Promotion to PROD":false, 
            "Data Promotion Approval":false
        }
    },
    "06_DOP_DAP": {
        permissions: [
            "Configure Rules [Add, Edit, Delete]",
            "Weightage",
            "Onboard New Data Asset",
            "Edit Data Asset",
            "Re-upload Sample Data",
            "Profile/CDE",
            "Rule Approval", 
            "Data Promotion to PROD", 
            "Data Promotion Approval"
        ],
        buttons: {
            "Onboard New Data Asset": false,
            "Edit Data Asset":false,
            "Re-upload Sample Data": false,
            "Weightage": false,
            "Configure Rules [Add, Edit, Delete]": false,
            "Profile/CDE":false,
            "Rule Approval":false, 
            "Data Promotion to PROD":true, 
            "Data Promotion Approval":false
        }
    },
    "07_DOP_DAR": {
        permissions: [
            "Configure Rules [Add, Edit, Delete]",
            "Weightage",
            "Onboard New Data Asset",
            "Edit Data Asset",
            "Re-upload Sample Data",
            "Profile/CDE",
            "Rule Approval", 
            "Data Promotion to PROD", 
            "Data Promotion Approval"
        ],
        buttons: {
            "Onboard New Data Asset": false,
            "Edit Data Asset":false,
            "Re-upload Sample Data": false,
            "Weightage": false,
            "Configure Rules [Add, Edit, Delete]": false,
            "Profile/CDE":false,
            "Rule Approval":false, 
            "Data Promotion to PROD":false, 
            "Data Promotion Approval":false
        }
    }
};

export const userLevelRoleMapping={
      "01_DOR_AD": {
        buttons: {
          "Onboard New Data Asset": true
        }
      },
      "02_DOR_DO": {
        buttons: {
          "Onboard New Data Asset": true
        }
      },
      "03_DOR_DG": {
        buttons: {
          "Onboard New Data Asset": true
        }
      },
      "04_DOR_DS": {
        buttons: {
          "Onboard New Data Asset": true
        }
      },
      "05_DOR_DE": {
        buttons: {
          "Onboard New Data Asset": false
        }
      },
}
